import { Col, Row } from "../Grid";
import DownArrow from "./DownArrow";
import Logo from "./Logo";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  productBar: {
    position: "relative",
    zIndex: "1",
    height: "3.1rem",
    width: "100%",
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  productBarMobile: {
    position: "relative",
    zIndex: "1",
    maxHeight: "3.1rem",
    height: "3.1rem",
    width: "100%",
    padding: 0,
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  productBarMobileNav: {
    lineHeight: "1.15",
    height: "auto",
    width: "100%",
    padding: 0,
    maxHeight: "1px",
    visibility: "hidden",
    transition: "max-height .5s ease",
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  mobileMenuArrow: {
    display: "none",
    "@media (max-width: 823px)": {
      display: "block"
    }
  },
  productsMenuButtonCheckbox: {
    display: "none",
    "&:checked ~ $productBarMobileNav": {
      visibility: "visible",
      maxHeight: "500px"
    }
  }
});

const ProductBar = ({ classes, children, logoSrc, logoLink, className }) => (
  <div>
    <div className={`${classes.productBar} ${className}`}>
      <Row middle>
        <Logo src={logoSrc} link={logoLink} />
        {children}
      </Row>
    </div>
    <div className={`${classes.productBarMobile} ${className}`}>
      <label className={classes.mobileMenuArrow} htmlFor="toggleMenu">
        <Row>
          <DownArrow />
          <Logo src={logoSrc} link={logoLink} />
        </Row>
      </label>
      <input
        type="checkbox"
        id="toggleMenu"
        className={classes.productsMenuButtonCheckbox}
        value="on"
      />
      <div className={`${classes.productBarMobileNav} ${className}`}>
        <Col middle center>
          {children}
        </Col>
      </div>
    </div>
  </div>
);

ProductBar.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  logoSrc: PropTypes.string.isRequired,
  logoLink: PropTypes.string.isRequired
};

export default injectSheet(styles)(ProductBar);



// WEBPACK FOOTER //
// ./src/components/ProductBar/ProductBar.jsx